export default "__VITE_ASSET__0lheIjfx__"